import { render, staticRenderFns } from "./UiTrading.vue?vue&type=template&id=003e567a&"
import script from "./UiTrading.vue?vue&type=script&lang=ts&"
export * from "./UiTrading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports